/**
 * Machine-readable error codes shared by server and clients.
 * Clients map these to localized (Turkish) messages; `message` is for logs/debugging.
 */
export const ErrorCode = {
    ValidationFailed: 'VALIDATION_FAILED',
    Unauthorized: 'UNAUTHORIZED',
    /** Authenticated, but missing the required `novachat.*` permission. */
    Forbidden: 'FORBIDDEN',
    /** Wrong e-mail or password. `message` carries Novadan's Turkish text when available. */
    InvalidCredentials: 'INVALID_CREDENTIALS',
    /** Wrong or expired 2FA code. `message` carries Novadan's Turkish text when available. */
    InvalidTwoFactorCode: 'INVALID_2FA_CODE',
    /** Novadan API did not answer in time or failed. */
    NovadanUnavailable: 'NOVADAN_UNAVAILABLE',
    RateLimited: 'RATE_LIMITED',
    NotFound: 'NOT_FOUND',
    PayloadTooLarge: 'PAYLOAD_TOO_LARGE',
    BadRequest: 'BAD_REQUEST',
    /** The only owner of a channel tried to leave it: hand ownership over or delete the channel first. */
    SoleOwner: 'SOLE_OWNER',
    /** Jira did not answer in time or failed. */
    JiraUnavailable: 'JIRA_UNAVAILABLE',
    /** The action needs the person's own Jira account: connect it in Settings (again). */
    JiraNotConnected: 'JIRA_NOT_CONNECTED',
    Internal: 'INTERNAL_ERROR',
};
//# sourceMappingURL=errors.js.map